import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ListIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`List`} {...props}>
    <Path
      fill="currentColor"
      d="M3 12.25a.75.75 0 0 1 0 1.5H1a.75.75 0 0 1 0-1.5h2ZM15 12.25a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1 0-1.5h9ZM3 7.25a.75.75 0 0 1 0 1.5H1a.75.75 0 0 1 0-1.5h2ZM15 7.25a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1 0-1.5h9ZM3 2.25a.75.75 0 0 1 0 1.5H1a.75.75 0 0 1 0-1.5h2ZM15 2.25a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1 0-1.5h9Z"
    />
  </Icon>
);

export default ListIcon;
